<template>
  <b-container>
    <h1><img src="../assets/OK.svg">{{ $t('registration.successTitle') }}</h1>
    <h5 class="pb-2">{{ $t('registration.successMessage') }}</h5>
    <h3 class="pb-4 serial">
      <img class="pr-1" src="../assets/sensor.svg">
      <b>{{ sn }}</b>
    </h3>
    <!-- <b-button variant="primary" v-on:click="done()">{{ $t('configureWifi') }}</b-button> -->
  </b-container>
</template>

<script>
export default {
  name: 'RegistrationSuccess',
  props: ['sn'],
  data() {
    return {};
  },
  methods: {
    done() {
      this.$router.replace({ name: 'HomePage' });
    }
  },
}
</script>

<style scoped>
.serial > img {
  height: 32px;
}
</style>
